// removed by extract-text-webpack-plugin
module.exports = {"music":"EHci","c":"TTF4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/music/index.less
// module id = 258
// module chunks = 0